import { render } from "./GroupInfo.vue?vue&type=template&id=387f0d3e&scoped=true"
import script from "./GroupInfo.vue?vue&type=script&lang=js"
export * from "./GroupInfo.vue?vue&type=script&lang=js"

import "./GroupInfo.vue?vue&type=style&index=0&id=387f0d3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387f0d3e"]])

export default __exports__